import Lottie from 'react-lottie';
import animationData from '../lotties/loading-2.json';

const NoData = () => {
  const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    }
  
  return (
    <>
      <div className="mx-auto rounded-lg mt-36">
        <Lottie
          options={defaultOptions}
          width={250}
          height={250}
        />
      </div>
    </>        
  )
}

export default NoData